import ImportBadgerAccordion from './src/BadgerAccordion'
import ImportBadgerAccordionItem from './src/BadgerAccordionItem'

export const BadgerAccordion = ImportBadgerAccordion;
export const BadgerAccordionItem = ImportBadgerAccordionItem;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-badger-accordion/index.js
// module id = paJE
// module chunks = 1